import { render } from "./AMLCheck.vue?vue&type=template&id=b4db0a2c&scoped=true"
import script from "./AMLCheck.vue?vue&type=script&lang=js"
export * from "./AMLCheck.vue?vue&type=script&lang=js"

import "./AMLCheck.vue?vue&type=style&index=0&id=b4db0a2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4db0a2c"]])

export default __exports__